import { useRef, useState, useEffect } from 'react';

// ----------------------------------------------------------------------

export function useScroller() {
  const scrollOffsetTop = 250;

  const prevScrollpos = useRef();
  const htmlScrollable = useRef();
  const fixedElementTop = useRef();

  const [bottomReached, setBottomReached] = useState(false);

  const handleScroll = (event) => {
    const elementScrollable = event.target.scrollingElement;
    const currentScrollPos = elementScrollable.scrollTop;
    const topReached = currentScrollPos < scrollOffsetTop;

    if (fixedElementTop.current) {
      if (topReached) {
        htmlScrollable.current.classList.remove('scroll__snap__parent', 'scrolling__down');
        fixedElementTop.current.classList.remove('scrolling__down');
      } else {
        htmlScrollable.current.classList.add('scroll__snap__parent');
        const isScrollingDown = prevScrollpos.current < currentScrollPos;
        htmlScrollable.current.classList.toggle('scrolling__down', isScrollingDown);
        fixedElementTop.current.classList.toggle('scrolling__down', isScrollingDown);
      }
      prevScrollpos.current = currentScrollPos;
    }

    const _bottomReached =
      elementScrollable.scrollHeight - currentScrollPos <
      scrollOffsetTop * 2 + elementScrollable.clientHeight;

    setBottomReached(!topReached && _bottomReached);
  };

  useEffect(() => {
    prevScrollpos.current = window.scrollY;
    htmlScrollable.current = document.querySelector('html');
    fixedElementTop.current = document.querySelector('.search__input__sticky');

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (fixedElementTop.current) fixedElementTop.current.classList.remove('scrolling__down');
      htmlScrollable.current.classList.remove('scroll__snap__parent', 'scrolling__down');
    };
  }, []);

  return { bottomReached };
}
